<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Date Ranges</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <cal-picker
                    v-model="form.tranDateFrom"
                    v-validate="tranDateFromValidation"
                    :label="labels.tranDateFrom"
                    :data-vv-as="labels.tranDateFrom"
                    :error-messages="errors.collect('form.tranDateFrom')"
                    data-vv-name="form.tranDateFrom">
                  </cal-picker>
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker
                    v-model="form.tranDateTo"
                    v-validate="tranDateToValidation"
                    :label="labels.tranDateTo"
                    :data-vv-as="labels.tranDateTo"
                    :error-messages="errors.collect('form.tranDateTo')"
                    data-vv-name="form.tranDateTo">
                  </cal-picker>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Filters</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="form.ttyRef"
                    :label="labels.ttyRef"
                    :error-messages="errors.collect('form.ttyRef')"
                    :data-vv-as="labels.ttyRef"
                    data-vv-name="form.ttyRef"
                    append-icon="mdi-magnify"
                    @click:append="showTreatyNoHelpList=true"
                    @click="showTreatyNoHelpList=true"
                    v-validate="'required'"
                    readonly/>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="form.branch"
                    :label="labels.branch"
                    :error-messages="errors.collect('form.branch')"
                    :data-vv-as="labels.branch"
                    data-vv-name="form.branch"
                    append-icon="mdi-magnify"
                    @click:append="showBranchHelpList=true"
                    @click="showBranchHelpList=true"
                    v-validate="'required'"
                    readonly/>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Report Settings</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
                    data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
      <v-dialog v-model="showBranchHelpList" width="900px" persistent>
        <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
      </v-dialog>
      <v-dialog v-model="showTreatyNoHelpList" width="900px">
        <treaty-no-help-list @close="doClose" @assign-treaty-info="assignTreatyInfo" />
      </v-dialog>
  </page>
</template>

<script>
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList2.vue'
import TreatyNoHelpList from '@/components/core/common/dialog/TreatyNoHelpList.vue'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'To',
        branch: 'Branch',
        ttyRef: 'Treaty Ref',
        reportType: 'Type of Report',
        format: 'Export Format',
        export: 'Export to',
        pbPrtParam: 'Print Run Time Parameters'
      },
      form: {
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        ttyRef: '',
        branch: 'All',
        format: 'PDF',
        pbPrtParam: false
      },
      menu: {},
      supportedFormat: [],
      loading: false,
      showBranchHelpList: false,
      showTreatyNoHelpList: false
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    riMenu() {
      return this.$store.state.reports.riReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.form.tranDateFrom !== '' && this.form.tranDateFrom !== null && this.form.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.form.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.form.tranDateTo !== '' && this.form.tranDateTo !== null && this.form.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.form.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.riReports.init !== 1) {
          await this.$store.dispatch('riReportsInit')
        }
        const apiURI = this.riMenu.ttyOutTransChklst
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    assignTreatyInfo(obj) {
      this.form.ttyRef = obj.ttyNo
    },
    doClose() {
      this.showBranchHelpList = false
      this.showTreatyNoHelpList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDateFrom = args[0]
        if (tranDateFrom) {
          return !(isAfter(removeTime(value), removeTime(tranDateFrom)))
        }
      }
    })
    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDateTo = args[0]
        if (tranDateTo) {
          return !(isAfter(removeTime(tranDateTo), removeTime(value)))
        }
      }
    })
  },
  mixins: [
    commonAjaxMixin,
    MessageMixin
  ],
  components: {
    MultiBranchHelpList,
    TreatyNoHelpList
  }
}
</script>
